import { makeStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme';

export const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.grey['100'],
    borderRadius: '4px',
    boxShadow: theme.shadows[1],
  },
  chipContainer: {
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    minHeight: 37,
    border: '1px solid #ced4da',
  },
  chipInput: {
    border: 0,
    boxShadow: 'none',
    background: 'none',
    padding: 0,
    marginTop: theme.spacing(2),
    width: '100%',
  },
  chipRoot: {
    marginTop: theme.spacing(2),
    marginBottom: 0,
  },
  tabsIndicator: {
    backgroundColor: 'white',
    height: '100%',
    zIndex: 1,
    borderRadius: '4px 4px 0 0',
  },
  scrollButton: {
    flex: '0 0 32px',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  tabRoot: {
    color: '#818B9D',
    borderRadius: '4px 4px 0 0',
    textTransform: 'initial',
    minWidth: 72,
    fontWeight: 400,
    '&:hover': {
      color: '#818B9D',
      opacity: 1,
    },
    '&:focus': {
      color: '#192542',
    },
    ['&$tabSelected' as any]: {
      color: '#192542',
      fontWeight: 500,
      boxShadow: theme.shadows[1],
    },
  },
  tabSelected: {},
  label: {
    position: 'relative',
    zIndex: 2,
    fontSize: 16,
  },
  typography: {
    padding: theme.spacing(2) * 3,
  },
  buttonAdd: {
    background: '#009358',
    color: '#fff',
    '&:hover': {
      background: '#036b41',
      color: '#fff',
    },
  },
  filterInputs: {
    padding: theme.typography.pxToRem(16),
    background: theme.palette.grey[200],
    position: 'relative',
  },
  filterField: {
    border: '2px dashed ' + theme.palette.primary.light,
    borderRadius: '0.3125rem',
    display: 'flex',
    minHeight: '4.5rem',
    color: theme.palette.primary.light,
    padding: theme.typography.pxToRem(16),
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    overflow: 'auto',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
    ['& > p' as any]: {
      textAlign: 'center',
      margin: 0,
    },
    ['& p.hide' as any]: {
      display: 'none',
    },
    ['& p.show' as any]: {
      display: 'inline-block',
      width: '100%',
      alignSelf: 'center',
    },
  },
  fieldClean: {
    display: 'block',
    alignSelf: 'center',
    whiteSpace: 'nowrap',
    ['&.hide' as any]: {
      display: 'none',
    },
  },
  input: {
    marginTop: 16,
    marginBottom: 16,
    position: 'relative',
  },
  bootstrapRoot: {
    padding: 0,
    ['label + &' as any]: {
      marginTop: theme.spacing(2) * 3,
    },
  },
  bootstrapInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: '15px',
    padding: '2px 2px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  bootstrapFormLabel: {
    fontSize: 18,
  },
  tableId: {
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      textAlign: 'right',
    },
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  iconList: {
    fontSize: 14,
    display: 'flex',
    justifyContent: 'flex-end',
    ['& $iconTable' as any]: {
      width: '100%',
      height: 'auto',
      position: 'relative',
      overflowX: 'auto',
      overflowY: 'hidden',
    },
    ['& $iconContainer' as any]: {
      display: 'flex',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('sm')]: {
        justifyContent: 'flex-start',
      },
    },
    ['& $iconItem' as any]: {
      textAlign: 'center',
      lineHeight: 1,
      paddingLeft: '0.5rem',
      [theme.breakpoints.up('sm')]: {
        paddingRight: '0.5rem',
      },
      '& > svg': {
        width: 20,
        [theme.breakpoints.up('sm')]: {
          width: 16,
        },
      },
      '& > svg > path': {
        fill: variables.palette.primary.light,
      },
    },
  },
  iconContainer: {},
  iconTable: {},
  iconItem: {},
  title: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  filtros: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      background: 'white',
      padding: 16,
      justifyContent: 'space-between',
    },
  },
  rangePicker: {
    display: 'flex',
    float: 'left',
    marginTop: '-5px',
    [theme.breakpoints.down('sm')]: {
      float: 'inherit',
    },
  },
  buttonFilter: {
    float: 'right',
    marginTop: '-5px',
    marginLeft: 8,
    [theme.breakpoints.down('sm')]: {
      float: 'inherit',
      marginTop: 16,
      marginLeft: 0,
    },
  },
  badge: {
    right: '-10px',
    backgroundColor: '#009358',
  },
  tabsRoot: {
    background: '#fff',
    minHeight: '28px',
  },
  customer: {
    fontSize: 14,
    lineHeight: '17px',
    fontWeight: 400,
    padding: '0 16px',

    '& div': {
      display: 'block',
      marginBottom: 5,

      '& span': {
        color: '#192542',
        minWidth: '50px',
        display: 'inline-block',
        fontWeight: 500,
      },
    },
  },
  widthColumn: {
    width: 8,
    background: 'red',
  },
  tabsRoot2: {
    background: '#fff',
    minHeight: '28px',
  },
  tabsIndicator2: {
    backgroundColor: '#eee',
    height: 0,
  },
  tabRoot2: {
    color: 'rgba(0,0,0,.65)',
    fontSize: 15,
    minWidth: '70px',
    background: 'white',
    textTransform: 'initial',
    fontWeight: 400,
    ['&$tabSelected' as any]: {
      color: '#192542',
      opacity: 1,
      borderRadius: '4px 4px 0 0',
    },
    '&:focus': {
      color: '#192542',
    },
    '& span': {
      fontSize: 14,
    },
  },
  spaceRight: {
    marginRight: 4,
  },
  tabSelected2: {
    background: '#eee',
    borderRadius: '4px 4px 0 0',
  },
  content: {
    background: 'white',
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    padding: '12px 24px',
    overflow: 'hidden',
  },
  tableAction: {
    '& span': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  emptyMessage: {
    textAlign: 'center',
    paddingTop: 20,
  },
}));
